export class DefinedFeatureFlags {
  static LogYard = 'LogYard';
  static Coil: string = 'Coil';
  static TrackIndividualLogs: string = 'TrackIndividualLogs';
  static MoveTimberFromLogSorterBins = 'MoveTimberFromLogSorterBins';
  static Bulk: string = 'Bulk';
}
